import {
  thickness,
  width,
  length,
  certification
} from '@/modules/standardItems/schemas/baseHeaders'

export function moistureResistant () {
  return {
    text: 'MR',
    value: 'moistureResistant',
    sortable: true,
    sort: 'boolean',
    render: 'boolean',
    align: 'center'
  }
}

export function fireRated () {
  return {
    text: 'FR',
    value: 'fireRated',
    sortable: true,
    sort: 'boolean',
    render: 'boolean',
    align: 'center'
  }
}

export function sheetStockHeaders () {
  return [
    thickness(),
    width(),
    length(),
    certification()
  ]
}

export default sheetStockHeaders
